import { put, select } from 'redux-saga/effects';
import notification from 'antd/lib/notification';
// internal
import history from '@app/components/router/history';
import { RootState } from '@app/store/typings/state/root';
import * as ActionType from '@app/store/typings/actions/brand.d';
import * as brandService from '@app/services/brand';
import { handleError } from '@app/utils/service';

export function* createBrand({ payload }: ActionType.CreateBrand) {
  try {
    const { status, data } = yield brandService.createBrand(payload);
    if (status === 201) {
      if (payload.file) {
        yield put<ActionType.BrandType>({
          type: 'KEY_BRAND_UPLOAD_PICTURE',
          payload: {
            brandId: data.data._id,
            type: 'create',
            file: payload.file,
          },
        });
      }
      notification.success({ message: 'Success', description: 'Create brand successfully' });
      history.push('/brand');
    }
  } catch (error: any) {
    const message = error.response.data.message;
    notification.error({ message: 'Error', description: message });
    handleError(error);
  }
}

export function* updateBrand({ payload }: ActionType.UpdateBrand) {
  try {
    const brandId: string = yield select((state: RootState) => state.brand.currentBrand._id);
    const { status } = yield brandService.updateBrand(brandId, payload.data, payload.isSameName);
    if (status === 200) {
      if (payload.data.file) {
        yield put<ActionType.BrandType>({
          type: 'KEY_BRAND_UPLOAD_PICTURE',
          payload: {
            brandId: brandId,
            type: 'update',
            file: payload.data.file,
          },
        });
      } else {
        yield put<ActionType.BrandType>({
          type: 'KEY_BRAND_FETCH_WITHID',
          payload: brandId,
        });
      }
      notification.success({ message: 'Success', description: 'Update brand successfully' });
    }
  } catch (error: any) {
    const message = error.response.data.message;
    notification.error({ message: 'Error', description: message });
    handleError(error);
  }
}
